import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Helmet } from 'react-helmet'

const BlazeFontsLoader = observer(() => {
  const { blazeFonts } = useRootStore()

  useEffect(
    function fetchFonts() {
      if (!blazeFonts.ready) {
        blazeFonts.fetchAll()
      }
    },
    [blazeFonts],
  )

  return (
    <Helmet>
      {blazeFonts.getByLoadingState('loading', 'loaded').map((font) => (
        <link key={font.family} href={font.url} rel="stylesheet" data-blaze-font="true" />
      ))}
    </Helmet>
  )
})

export { BlazeFontsLoader }
